import { useState } from "react";
import Form from "./components/Form";
import MarkdownRenderer from "./components/MarkdownViewer";
import { AppContext } from './lib/Context';

export default function App() {
  const [response, setResponse] = useState('');

  return (
    <AppContext.Provider value={response}>
      <div className="min-h-screen bg-gray-50 text-gray-900">
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-earthy1 to-earthy2">
          <Form onSubmit={setResponse} />
          {response !== '' && (
            <MarkdownRenderer source={response} />
          )}
        </div>
      </div>
    </AppContext.Provider>
  );
}
